import "./newWO.css";
import { useState, useEffect, useCallback, useRef } from "react";
import {
  differenceInCalendarDays,
  format,
  isBefore,
  isValid,
  parseISO,
  startOfDay,
} from "date-fns";
import Footer from "./Footer.js";
import FooterCreate from "./FooterCreate.js";
import Progressbar from "./Progressbar.js";
import GroupedStep1 from "./GroupedStep1.js";
import GroupedStep2 from "./GroupedStep2.js";
import GroupedStep3 from "./GroupedStep3.js";
import NewWoCreated from "./NewWoCreated.js";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig.js";
import { validate, formatDate } from "../Utils.js";
import { v4 as uuidv4 } from "uuid";
import { Modal } from "react-bootstrap";
import WorkOrderPDF from "./WorkOrderPDF.js";
import { pdf } from "@react-pdf/renderer";
import { useClarityEventTracking } from "../hooks/useClarityTracking.js";

const MainWindowGrouped = ({
  setShowCreateWO,
  customer_no,
  updateWoList,
  showSavedWorkOrders,
  setShowSavedWorkOrders,
  hasExtraProducts,
  selectedAgreementId = null,
  selectedAgreementName = null,
}) => {
  const ApiDomain = import.meta.env.VITE_BACKEND_API_HOST;
  let numberOfFiles = 0;

  const [isBack, setIsBack] = useState(false);
  const [remValKommun, setRemValKommun] = useState("");
  const [sla, setSla] = useState({
    min_end_time: "",
    min_start_time: "",
  });
  const [wono, setWono] = useState("");
  const [loading, setLoading] = useState(false);
  const [addingFiles, setAddingFiles] = useState(false);
  const [generatingPDF, setGeneratingPDF] = useState(false);
  const [remValLine, setRemValLine] = useState("");
  const [stepState, setStepState] = useState(1);
  const [stepCounter, setStepCounter] = useState(1);
  const [kommuner, setKommuner] = useState([]);
  const [produkter, setProdukter] = useState([]);
  const [agreementInfoText, setAgreementInfoText] = useState(null);
  const [agreementInfoSeverity, setAgreementInfoSeverity] = useState("warning");
  const [formToShow, setFormToShow] = useState([]);
  const [files, setFiles] = useState([]);
  const [deliveryAddressInfo, setDeliveryAddressInfo] = useState(null);
  const [deliveryAddressLoading, setDeliveryAddressLoading] = useState(false);
  const [deliveryAddressError, setDeliveryAddressError] = useState("");
  const [deliveryAddressKey, setDeliveryAddressKey] = useState("");
  const { instance, accounts } = useMsal();
  const [slaCreate, setSlaCreate] = useState({ start: "", end: "" });
  const [createWoError, setCreateWoError] = useState(false);
  const [chosenWo, setChosenWo] = useState({});
  const [extraProducts, setExtraProducts] = useState([]);
  const [isCreateWoBtnDisabled, setIsCreateWoBtnDisabled] = useState(false);
  const createWoFlowStartedRef = useRef(false);
  const createWoPostStartedRef = useRef(false);
  const trackEvent = useClarityEventTracking();

  const [newWoData, setNewWoData] = useState({
    kommun: "",
    product: "",
    requiredStartDate: "",
    requiredEndDate: "",
    streetAddress: "",
    key: "",
    keyid: "",
    customerName: "",
    customerPhone: "",
    customerAddress: "",
    customerPostalcode: "",
    customerCity: "",
    customerKeyID: "",
    customerKeyAddress: "",
    customerKeyName: "",
    customerKeyPhone: "",
    referensnummer: "",
    clientContact: accounts[0].name,
    clientPhone: accounts[0].idTokenClaims.mobile,
    siteID: "",
    siteAddress: "",
    sitePostalcode: "",
    siteCity: "",
    siteFloor: "",
    siteRow: "",
    accessSiteKeyID: "",
    accessSiteAddress: "",
    accessSitePostalcode: "",
    accessSiteCity: "",
    accessSiteName: "",
    accessSitePhone: "",
    longWorkDesc: "",
    lineNo: "",
    kobject: "",
    department: "",
    contract_id: "",
    maint_org: "",
    work_type_id: "",
    customer_no: customer_no,
    equipmentID: "",
    equipmentInterface: "",
    equipmentConnectionNumber: "",
    mtrlEquipment: "",
    sparePart1: "",
    sparePart2: "",
    sparePart3: "",
    mtrlReturnMtrl: "",
    infoMtrlReturnMtrl: "",
    sendMaterial: "",
    siteExists: "",
    customerCompanyName: "",
    clientContactEmail: accounts[0].idTokenClaims.email,
    processState: "UNDER_CONSTUCTION",
    test1: "",
    test2: "",
    customerCallForAccess: "",
    accessSiteCallForAccess: "",
    transactionid: uuidv4(),
    shortDesc: "",
    savedId: -1,
  });

  const [validateIsErr, setValidateIsErr] = useState({});

  const createWoOnce = () => {
    if (createWoPostStartedRef.current) {
      return;
    }

    createWoPostStartedRef.current = true;
    getInstance("CREATEWO");
  };

  const isFormStepActive = useCallback(
    (stepIndex) => {
      return formToShow?.some(
        (step) => step.Index === stepIndex && step.IsActivated
      );
    },
    [formToShow]
  );

  const hasAnyActiveStep = useCallback(
    (stepIndexes) => {
      return stepIndexes.some((index) => isFormStepActive(index));
    },
    [isFormStepActive]
  );

  const hasGroup2Steps = hasAnyActiveStep([4, 5, 6, 7]);
  const maxStep = hasGroup2Steps ? 3 : 2;

  const createBaseErr = () => ({
    kommun: false,
    product: false,
    requiredStartDate: false,
    requiredEndDate: false,
    streetAddress: false,
    key: false,
    keyid: false,
    customerName: false,
    customerPhone: false,
    customerAddress: false,
    customerPostalcode: false,
    customerCity: false,
    customerKeyID: false,
    customerKeyAddress: false,
    customerKeyName: false,
    customerKeyPhone: false,
    referensnummer: false,
    clientContact: false,
    clientPhone: false,
    siteID: false,
    siteAddress: false,
    sitePostalcode: false,
    siteCity: false,
    siteFloor: false,
    siteRow: false,
    accessSiteKeyID: false,
    accessSiteAddress: false,
    accessSitePostalcode: false,
    accessSiteCity: false,
    accessSiteName: false,
    accessSitePhone: false,
    longWorkDesc: false,
    lineNo: false,
    kobject: false,
    department: false,
    contract_id: false,
    maint_org: false,
    work_type_id: false,
    customer_no: customer_no,
    equipmentID: false,
    equipmentInterface: false,
    equipmentConnectionNumber: false,
    mtrlEquipment: false,
    sparePart1: false,
    sparePart2: false,
    sparePart3: false,
    mtrlReturnMtrl: false,
    infoMtrlReturnMtrl: false,
    sendMaterial: false,
    siteExists: false,
    customerCompanyName: false,
    clientContactEmail: false,
    test1: false,
    test2: false,
    shortDesc: false,
  });

  const requestDeliveryAddress = useCallback(() => {
    if (!newWoData.kobject) {
      setDeliveryAddressError(
        "Välj objekt i steg 1 för att visa leveransadressen."
      );
      setDeliveryAddressInfo(null);
      return;
    }

    if (deliveryAddressKey === newWoData.kobject && deliveryAddressInfo) {
      return;
    }

    setDeliveryAddressLoading(true);
    setDeliveryAddressError("");
    setDeliveryAddressInfo(null);
    getInstance("DELIVERY_ADDRESS", null, newWoData.kobject);
  }, [newWoData.kobject, deliveryAddressKey, deliveryAddressInfo]);

  function getInstance(type, file = null, id = null) {
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        if (type === "KOMMUN") {
          myFetchKommun(response);
        } else if (type === "PRODUKT") {
          myFetchProdukt(response);
        } else if (type === "CREATEWO") {
          myFetchcreateWO(response);
        } else if (type === "FILE") {
          uploadFiles(file, response);
        } else if (type === "PDF_UPLOAD") {
          generateAndUploadPDF(response);
        } else if (type === "PRODUKT_SLA") {
          return myFetchProduktSla(response);
        } else if (type === "SAVEWO") {
          saveWorkOrderToDb(response);
        } else if (type === "FORM_TO_SHOW") {
          myFetchFormsToShow(response);
        } else if (type === "DELETE_SAVED_WO") {
          deleteSavedWorkOrders(response, id);
        } else if (type === "DELIVERY_ADDRESS") {
          myFetchDeliveryAddress(response, id);
        } else if (type === "EXTRA_PRODUCTS") {
          myFetchExtraProducts(response);
        }
      })
      .catch((error) => {
        instance
          .acquireTokenPopup({
            ...loginRequest,
            account: accounts[0],
          })
          .then((response) => {
            if (type === "KOMMUN") {
              myFetchKommun(response);
            } else if (type === "PRODUKT") {
              myFetchProdukt(response);
            } else if (type === "CREATEWO") {
              myFetchcreateWO(response);
            } else if (type === "FILE") {
              uploadFiles(file, response);
            } else if (type === "PDF_UPLOAD") {
              generateAndUploadPDF(response);
            } else if (type === "PRODUKT_SLA") {
              return myFetchProduktSla(response);
            } else if (type === "SAVEWO") {
              saveWorkOrderToDb(response);
            } else if (type === "FORM_TO_SHOW") {
              myFetchFormsToShow(response);
            } else if (type === "DELETE_SAVED_WO") {
              deleteSavedWorkOrders(response, id);
            } else if (type === "DELIVERY_ADDRESS") {
              myFetchDeliveryAddress(response, id);
            } else if (type === "EXTRA_PRODUCTS") {
              myFetchExtraProducts(response);
            }
            console.log(error);
          });
      });
  }

  function deleteSavedWorkOrders(response, id) {
    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;
    headers.append("Authorization", bearer);
    const options = {
      method: "DELETE",
      headers: headers,
    };
    const url = `https://${ApiDomain}/UserSaveWorkOrder/delete/${id}`;

    fetch(url, options)
      .then((response) => {
        if (!response.ok) {
          console.log("Fel vid borttagning av wo.");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function fetchWithTimeout(resource, options = {}, file) {
    const { timeout = 80000 } = options;

    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    const formData = new FormData();
    formData.append("fileUpload", file);

    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
      method: "POST",
      body: formData,
    });

    clearTimeout(id);
    return response;
  }

  async function uploadFiles(file, responseToken) {
    try {
      if (wono.length !== 8) {
        return;
      }

      const headers = new Headers();
      const bearer = `Bearer ${responseToken.accessToken}`;
      headers.append("Authorization", bearer);

      const url = `https://${ApiDomain}/Ora/ora/Files/Uplod/singel?wono=${wono}`;

      const response = await fetchWithTimeout(
        url,
        {
          headers: headers,
          timeout: 300000,
        },
        file
      );

      const returnVal = await response.json();

      if (files.length === numberOfFiles) {
        setAddingFiles(false);
      }

      return returnVal;
    } catch (error) {
      if (files.length === numberOfFiles) {
        setAddingFiles(false);
      }
      return "";
    }
  }

  function delayFile(file, i) {
    setTimeout(() => {
      getInstance("FILE", file);
    }, 1000 * i);
  }

  function checkStartEndTime() {
    if (
      newWoData.requiredStartDate !== "" ||
      newWoData.requiredEndDate !== ""
    ) {
      setNewWoData((prev) => ({
        ...prev,
        processState: "DONE",
      }));
      getInstance("PRODUKT_SLA");
    } else {
      createWoOnce();
    }
  }

  useEffect(() => {
    const checkSLA = async () => {
      if (newWoData.kobject === "" || newWoData.lineNo === "") {
        return;
      }

      if (
        newWoData.test2 === "DONE" ||
        newWoData.processState === "UNDER_CONSTUCTION"
      ) {
        return;
      }

      if (newWoData.test2 === "SLACHANGE") {
        createWoOnce();
        setNewWoData((prev) => ({
          ...prev,
          test2: "DONE",
        }));
      } else {
        if (
          newWoData.requiredStartDate === "" &&
          newWoData.requiredEndDate === ""
        ) {
          createWoOnce();
        } else if (
          newWoData.requiredStartDate !== "" &&
          newWoData.requiredEndDate === ""
        ) {
          if (slaCreate.start !== "") {
            if (
              newWoData.requiredStartDate.replace("T", " ") < slaCreate.start
            ) {
              if (
                window.confirm(
                  "Starttid kommer ändras till " +
                    slaCreate.start +
                    " är det ok?"
                )
              ) {
                setNewWoData((prev) => ({
                  ...prev,
                  requiredStartDate: slaCreate.start,
                  test2: "SLACHANGE",
                }));
              } else {
                cancelCreateWoBecauseOfSla();
                return;
              }
            } else {
              createWoOnce();
            }
          }
        } else if (
          newWoData.requiredStartDate === "" &&
          newWoData.requiredEndDate !== ""
        ) {
          if (slaCreate.end !== "") {
            if (newWoData.requiredEndDate.replace("T", " ") < slaCreate.end) {
              if (
                window.confirm(
                  "Sluttid kommer ändras till " + slaCreate.end + " är det ok?"
                )
              ) {
                setNewWoData((prev) => ({
                  ...prev,
                  requiredEndDate: slaCreate.end,
                  test2: "SLACHANGE",
                }));
              } else {
                cancelCreateWoBecauseOfSla();
                return;
              }
            } else {
              createWoOnce();
            }
          }
        } else if (
          newWoData.requiredStartDate !== "" &&
          newWoData.requiredEndDate !== ""
        ) {
          let isCre = false;
          let isChange = false;

          if (slaCreate.start !== "") {
            if (
              newWoData.requiredStartDate.replace("T", " ") < slaCreate.start
            ) {
              if (
                window.confirm(
                  "Starttid kommer ändras till " +
                    slaCreate.start +
                    " är det ok?"
                )
              ) {
                setNewWoData((prev) => ({
                  ...prev,
                  requiredStartDate: slaCreate.start,
                  test2: "SLACHANGE",
                }));
                isChange = true;
              } else {
                cancelCreateWoBecauseOfSla();
                return;
              }
            } else {
              isCre = true;
            }
          }

          if (slaCreate.end !== "") {
            if (newWoData.requiredEndDate.replace("T", " ") < slaCreate.end) {
              if (
                window.confirm(
                  "Sluttid kommer ändras till " + slaCreate.end + " är det ok?"
                )
              ) {
                setNewWoData((prev) => ({
                  ...prev,
                  requiredEndDate: slaCreate.end,
                  test2: "SLACHANGE",
                }));
                isChange = true;
              } else {
                cancelCreateWoBecauseOfSla();
                return;
              }
            } else {
              isCre = true;
            }
          }

          if (isCre === true && isChange === false) {
            createWoOnce();
          }
        }
      }
    };

    checkSLA();
  }, [
    slaCreate,
    newWoData.test2,
    newWoData.kobject,
    newWoData.lineNo,
    newWoData.processState,
    newWoData.requiredStartDate,
    newWoData.requiredEndDate,
  ]);

  const cancelCreateWoBecauseOfSla = () => {
    window.alert("Order kommer inte kunna skapas med denna SLA tid.");

    setNewWoData((prev) => ({
      ...prev,
      processState: "UNDER_CONSTUCTION",
      test2: "",
    }));

    createWoFlowStartedRef.current = false;
    createWoPostStartedRef.current = false;

    setIsCreateWoBtnDisabled(false);
  };

  const saveWO = async () => {
    trackEvent("Spara beställning");

    if (
      window.confirm(`Du kommer spara eller uppdatera en version av denna 
    beställning med namn ${newWoData.shortDesc} 
    för att fortsätta att arbeta med den senare.
    Vill du det?`)
    ) {
      if (files.length > 0) {
        window.alert(`Observera att filerna du lagt på beställningen inte kommer sparas. 
          Dessa kommer du få lägga till igen när beställningen ska skapas.`);
      }
      getInstance("SAVEWO");
    }
  };

  const saveWorkOrderToDb = async (responseToken) => {
    let copyOfnewWoData = newWoData;

    if (copyOfnewWoData.test2 === "DONE") {
      copyOfnewWoData = { ...copyOfnewWoData, test2: "" };
    }

    const headers = new Headers();
    const bearer = `Bearer ${responseToken.accessToken}`;
    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json");

    const options = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(copyOfnewWoData),
    };

    const name = newWoData.shortDesc;
    const url = `https://${ApiDomain}/UserSaveWorkOrder/save?saveName=${name}`;
    const response = await fetch(url, options);

    if (response.ok) {
      window.alert("Arbetsorder utkast sparad!");
    } else {
      window.alert("Misslyckades att spara arbetsorder utkast!");
    }
  };

  const createWO = async () => {
    if (createWoFlowStartedRef.current) {
      return;
    }

    createWoFlowStartedRef.current = true;
    createWoPostStartedRef.current = false;

    trackEvent("Skapa order");
    setIsCreateWoBtnDisabled(true);
    checkStartEndTime();
  };

  const myFetchcreateWO = async (responseToken) => {
    setLoading(true);

    const headers = new Headers();
    const bearer = `Bearer ${responseToken.accessToken}`;
    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json");

    const options = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(newWoData),
    };

    const url = `https://${ApiDomain}/Ora/ora/post/create/wo`;
    const response = await fetch(url, options);

    if (!response.ok) {
      setCreateWoError(true);
    } else {
      const data = await response.json();
      setWono(data.Message);
    }
  };

  const generateAndUploadPDF = async (responseToken) => {
    setGeneratingPDF(true);

    try {
      const blob = await pdf(
        <WorkOrderPDF
          workOrderData={newWoData}
          wono={wono}
          formToShow={formToShow}
          deliveryInfo={deliveryAddressInfo}
        />
      ).toBlob();

      const pdfFile = new File(
        [blob],
        `${wono}-${newWoData.referensnummer}-${format(
          new Date(),
          "yyyyMMdd_HHmmss"
        )}.pdf`,
        {
          type: "application/pdf",
          lastModified: new Date().getTime(),
        }
      );

      const headers = new Headers();
      const bearer = `Bearer ${responseToken.accessToken}`;
      headers.append("Authorization", bearer);

      const formData = new FormData();
      formData.append("file", pdfFile);

      let url = `https://${ApiDomain}/Workorder/orderconfirmation/${wono}?refNbr=${newWoData.referensnummer}&statusUpdatesEmail=${newWoData.statusUpdatesEmail || ""}`;

      if (newWoData.contract_id) {
        url += `&agreementId=${newWoData.contract_id}`;
      }

      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: formData,
      });

      const responseData = await response.json();
      setGeneratingPDF(false);
      return responseData;
    } catch (error) {
      setGeneratingPDF(false);
      return null;
    }
  };

  useEffect(() => {
    let i = 0;

    if (files.length > 0 && wono.length === 8) {
      numberOfFiles = files.length;
      setAddingFiles(true);

      Array.from(files).forEach((file) => {
        i += 1;
        delayFile(file, i);
      });
    }

    if (newWoData.savedId !== -1 && wono.length === 8) {
      getInstance("DELETE_SAVED_WO", null, newWoData.savedId);
    }

    if (wono.length === 8) {
      getInstance("PDF_UPLOAD");
    }
  }, [wono]);

  useEffect(() => {
    setRemValLine("");
    setNewWoData((prev) => ({
      ...prev,
      lineNo: "",
      contract_id: "",
      maint_org: "",
      work_type_id: "",
      product: "",
      requiredStartDate: "",
      requiredEndDate: "",
      shortDesc: "",
    }));
    setSla({
      min_end_time: "",
      min_start_time: "",
    });
  }, [remValKommun]);

  useEffect(() => {
    getInstance("FORM_TO_SHOW");
  }, [newWoData.product]);

  useEffect(() => {
    setDeliveryAddressInfo(null);
    setDeliveryAddressError("");
    setDeliveryAddressKey("");
    setDeliveryAddressLoading(false);
  }, [newWoData.kobject]);

  useEffect(() => {
    getInstance("KOMMUN");
    getInstance("EXTRA_PRODUCTS");
  }, []);

  useEffect(() => {
    if (!hasGroup2Steps && stepState === 2) {
      setStepState(3);
      setStepCounter(2);
      return;
    }

    if (stepState === 3) {
      setStepCounter(hasGroup2Steps ? 3 : 2);
    }
  }, [hasGroup2Steps, stepState]);

  function myFetchKommun(response) {
    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;
    headers.append("Authorization", bearer);

    const options = {
      method: "GET",
      headers: headers,
    };

    const url = `https://${ApiDomain}/Ora/ora/get/kommuner?customer_id=${customer_no}`;

    fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        setKommuner(data);
      })
      .catch((error) => console.log(error));
  }

  function myFetchDeliveryAddress(response, kobject) {
    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;
    headers.append("Authorization", bearer);

    const options = {
      method: "GET",
      headers: headers,
    };

    const selectedKey = kobject || newWoData.kobject;

    if (!selectedKey) {
      setDeliveryAddressLoading(false);
      return;
    }

    const url = `https://${ApiDomain}/address/delivery/${selectedKey}`;

    fetch(url, options)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Delivery address request failed");
        }
        return response.json();
      })
      .then((data) => {
        const payload = Array.isArray(data) && data.length > 0 ? data[0] : null;
        setDeliveryAddressInfo(payload);
        setDeliveryAddressKey(selectedKey);

        if (!payload) {
          setDeliveryAddressError("Ingen leveransinformation hittades.");
        } else {
          setDeliveryAddressError("");
        }
      })
      .catch((error) => {
        console.log(error);
        setDeliveryAddressInfo(null);
        setDeliveryAddressError("Kunde inte hämta leveransinformation.");
      })
      .finally(() => {
        setDeliveryAddressLoading(false);
      });
  }

  useEffect(() => {
    if (newWoData.kobject.length !== 0) {
      getInstance("PRODUKT");
    } else {
      setProdukter([]);
      setAgreementInfoText(null);
      setAgreementInfoSeverity("warning");
    }
  }, [newWoData.kobject]);

  function myFetchProdukt(response) {
    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;
    headers.append("Authorization", bearer);

    const options = {
      method: "GET",
      headers: headers,
    };

    let url = `https://${ApiDomain}/Ora/ora/get/styrdata?mch_code=${newWoData.kobject}&customer_id=${customer_no}`;

    if (hasExtraProducts && selectedAgreementId !== null) {
      url += `&agreement=${selectedAgreementId}`;
    }

    fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        const today = startOfDay(new Date());

        const contractDates = data
          .map((item) => item.NoNewWorkOrdersAllowedFromDate)
          .filter(Boolean)
          .map((dateText) => parseISO(dateText))
          .filter((dateValue) => isValid(dateValue));

        if (contractDates.length > 0) {
          const firstBlockedDate = contractDates.reduce((earliest, current) =>
            isBefore(current, earliest) ? current : earliest
          );

          if (isBefore(today, firstBlockedDate)) {
            const daysLeft = differenceInCalendarDays(firstBlockedDate, today);
            setAgreementInfoText(
              `Ditt avtal löper ut om ${daysLeft} dagar, efter detta kommer du inte kunna lägga fler beställningar. Dina pågående beställningar är möjliga att se tills dessa är avslutade.`
            );
            setAgreementInfoSeverity("warning");
          } else {
            setAgreementInfoText(
              "Du kan inte längre lägga några beställningar på det här avtalet. Dina pågående beställningar är möjliga att se tills dessa är avslutade."
            );
            setAgreementInfoSeverity("error");
          }
        } else {
          setAgreementInfoText(null);
          setAgreementInfoSeverity("warning");
        }

        const filteredData = data.filter((item) => {
          if (item.ser_contr_line_alt_desc_21 === "YES") {
            return false;
          }

          const blockedFromDate = item.NoNewWorkOrdersAllowedFromDate;

          if (!blockedFromDate) {
            return true;
          }

          const parsedBlockedDate = parseISO(blockedFromDate);

          if (!isValid(parsedBlockedDate)) {
            return true;
          }

          return isBefore(today, parsedBlockedDate);
        });

        setProdukter(filteredData);
      })
      .catch((error) => console.log(error));
  }

  function myFetchExtraProducts(response) {
    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;
    headers.append("Authorization", bearer);

    const options = {
      method: "GET",
      headers: headers,
    };

    const url = `https://${ApiDomain}/Ora/extraProducts?agreement=${selectedAgreementId}`;

    fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        setExtraProducts(data);
      })
      .catch((error) => console.log(error));
  }

  function myFetchFormsToShow(response) {
    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;
    headers.append("Authorization", bearer);

    const options = {
      method: "GET",
      headers: headers,
    };

    let url = `https://${ApiDomain}/DynamicForm/form?customerId=${customer_no}&productId=${newWoData.work_type_id}`;

    if (newWoData.work_type_id && newWoData.contract_id) {
      url += `&agreementId=${newWoData.contract_id}`;
    }

    fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        setFormToShow(data);
      })
      .catch((error) => console.log(error));
  }

  function myFetchProduktSla(response) {
    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;
    headers.append("Authorization", bearer);

    const options = {
      method: "GET",
      headers: headers,
    };

    const url = `https://${ApiDomain}/Ora/ora/get/styrdata?mch_code=${newWoData.kobject}&customer_id=${customer_no}&agreement=${newWoData.contract_id}`;

    fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        data.forEach(({ line_no, min_start_time, min_end_time }) => {
          if (line_no === newWoData.lineNo) {
            setSlaCreate((prev) => {
              if (prev.start === min_start_time && prev.end === min_end_time) {
                return prev;
              }

              return {
                ...prev,
                start: min_start_time,
                end: min_end_time,
              };
            });
          }
        });
      })
      .catch((error) => console.log(error));
  }

  const exitWindow = async () => {
    setShowCreateWO(false);
  };

  const nextWindow = async () => {
    setIsBack(false);

    if (validateFields()) {
      return;
    }

    if (stepState === 1) {
      if (hasGroup2Steps) {
        setStepState(2);
        setStepCounter(2);
      } else {
        setStepState(3);
        setStepCounter(2);
      }
      return;
    }

    if (stepState === 2) {
      setStepState(3);
      setStepCounter(hasGroup2Steps ? 3 : 2);
    }
  };

  const backWindow = async () => {
    setIsBack(true);

    if (stepState === 3) {
      if (hasGroup2Steps) {
        setStepState(2);
        setStepCounter(2);
      } else {
        setStepState(1);
        setStepCounter(1);
      }
      return;
    }

    if (stepState === 2) {
      setStepState(1);
      setStepCounter(1);
    }
  };

  useEffect(() => {
    let localChosenWo = chosenWo;

    if ("referensnummer" in localChosenWo) {
      localChosenWo = { ...localChosenWo, transactionid: uuidv4() };
      setNewWoData(localChosenWo);
    }
  }, [chosenWo]);

  function validateFields() {
    let ret = false;
    let err = createBaseErr();

    validate(newWoData, err);

    if (stepState === 1) {
      if (isFormStepActive(1)) {
        if (newWoData.kobject === "") {
          err = { ...err, kobject: true };
          ret = true;
        } else {
          err = { ...err, kobject: false };
        }

        if (newWoData.product === "") {
          err = { ...err, product: true };
          ret = true;
        } else {
          err = { ...err, product: false };
        }

        if (newWoData.shortDesc === "") {
          err = { ...err, shortDesc: true };
          ret = true;
        } else {
          err = { ...err, shortDesc: false };
        }

        if (
          newWoData.requiredStartDate === "" &&
          newWoData.requiredEndDate === ""
        ) {
          if (
            !window.confirm(
              "Du har ej angivet start eller stopptid för din arbetsorder. Utan önskad datumangivelse för start eller stopp kan skapad arbetsorder inte prioriteras i enlighet med avtalad SLA. Vill du fortsätta ändå?"
            )
          ) {
            ret = true;
          }
        }

        if (
          newWoData.requiredStartDate !== "" &&
          sla.min_start_time !== "" &&
          sla.min_start_time !== null
        ) {
          if (
            newWoData.requiredStartDate.replace("T", " ") < sla.min_start_time
          ) {
            alert("Datumet är tidigare än SLA tid: " + sla.min_start_time);
            err = { ...err, requiredStartDate: true };
            ret = true;
          } else {
            err = { ...err, requiredStartDate: false };
          }
        } else if (
          newWoData.requiredStartDate !== "" &&
          sla.min_start_time === null
        ) {
          if (
            newWoData.requiredStartDate.replace("T", " ") <
            formatDate(new Date())
          ) {
            alert(
              "Start datumet är tidigare än nu: " +
                newWoData.requiredStartDate.replace("T", " ")
            );
            err = { ...err, requiredStartDate: true };
            ret = true;
          } else {
            err = { ...err, requiredStartDate: false };
          }
        } else {
          err = { ...err, requiredStartDate: false };
        }

        if (
          newWoData.requiredEndDate !== "" &&
          sla.min_end_time !== "" &&
          sla.min_end_time !== null
        ) {
          if (newWoData.requiredEndDate.replace("T", " ") < sla.min_end_time) {
            alert("Datumet är tidigare än SLA tid: " + sla.min_end_time);
            err = { ...err, requiredEndDate: true };
            ret = true;
          } else {
            err = { ...err, requiredEndDate: false };
          }
        } else if (
          newWoData.requiredEndDate !== "" &&
          sla.min_end_time === null
        ) {
          if (
            newWoData.requiredEndDate.replace("T", " ") < formatDate(new Date())
          ) {
            alert(
              "Slut datumet är tidigare än nu: " +
                newWoData.requiredEndDate.replace("T", " ")
            );
            err = { ...err, requiredEndDate: true };
            ret = true;
          } else {
            err = { ...err, requiredEndDate: false };
          }
        } else {
          err = { ...err, requiredEndDate: false };
        }

        if (
          newWoData.requiredStartDate !== "" &&
          newWoData.requiredEndDate !== "" &&
          err.requiredStartDate === false &&
          err.requiredEndDate === false
        ) {
          if (
            newWoData.requiredStartDate.replace("T", " ") >=
            newWoData.requiredEndDate.replace("T", " ")
          ) {
            alert(
              "Startdatum är senare slutdatum:\n" +
                newWoData.requiredStartDate.replace("T", " ") +
                " är större än " +
                newWoData.requiredEndDate.replace("T", " ")
            );
            err = { ...err, requiredStartDate: true, requiredEndDate: true };
            ret = true;
          } else {
            err = { ...err, requiredStartDate: false, requiredEndDate: false };
          }
        }

        if (newWoData.clientContact === "") {
          err = { ...err, clientContact: true };
          ret = true;
        } else {
          err = { ...err, clientContact: false };
        }

        if (
          !/^[A-Za-z0-9ÅÄÖåäö,-]*$/.test(newWoData.referensnummer) ||
          newWoData.referensnummer === ""
        ) {
          err = { ...err, referensnummer: true };
          ret = true;
        } else {
          err = { ...err, referensnummer: false };
        }

        if (newWoData.clientContactEmail !== "") {
          if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
              newWoData.clientContactEmail
            )
          ) {
            err = { ...err, clientContactEmail: true };
            ret = true;
          } else {
            err = { ...err, clientContactEmail: false };
          }
        } else {
          err = { ...err, clientContactEmail: true };
          ret = true;
        }

        if (newWoData.clientPhone === "") {
          err = { ...err, clientPhone: true };
          ret = true;
        } else {
          if (!/^\+?[0-9]*$/.test(newWoData.clientPhone)) {
            err = { ...err, clientPhone: true };
            ret = true;
          } else {
            err = { ...err, clientPhone: false };
          }
        }
      } else {
        err = {
          ...err,
          kobject: false,
          product: false,
          shortDesc: false,
          requiredStartDate: false,
          requiredEndDate: false,
          clientContact: false,
          referensnummer: false,
          clientContactEmail: false,
          clientPhone: false,
        };
      }

      if (isFormStepActive(2)) {
        if (newWoData.customerName === "") {
          err = { ...err, customerName: true };
          ret = true;
        } else {
          err = { ...err, customerName: false };
        }

        if (newWoData.customerPhone === "") {
          err = { ...err, customerPhone: true };
          ret = true;
        } else {
          err = { ...err, customerPhone: false };
        }

        if (newWoData.customerAddress === "") {
          err = { ...err, customerAddress: true };
          ret = true;
        } else {
          err = { ...err, customerAddress: false };
        }

        if (!/^[0-9]{3}\s?[0-9]{2}$/.test(newWoData.customerPostalcode)) {
          err = { ...err, customerPostalcode: true };
          ret = true;
        } else {
          err = { ...err, customerPostalcode: false };
        }

        if (newWoData.customerCity === "") {
          err = { ...err, customerCity: true };
          ret = true;
        } else {
          err = { ...err, customerCity: false };
        }
      } else {
        err = {
          ...err,
          customerName: false,
          customerPhone: false,
          customerAddress: false,
          customerPostalcode: false,
          customerCity: false,
        };
      }

      if (isFormStepActive(3)) {
        if (newWoData.customerKeyPhone === "") {
          err = { ...err, customerKeyPhone: false };
        } else {
          if (!/^\+?[0-9]*$/.test(newWoData.customerKeyPhone)) {
            err = { ...err, customerKeyPhone: true };
            ret = true;
          } else {
            err = { ...err, customerKeyPhone: false };
          }
        }
      } else {
        err = {
          ...err,
          customerKeyPhone: false,
        };
      }

      if (isFormStepActive(8)) {
        if (!newWoData.longWorkDesc || newWoData.longWorkDesc.trim() === "") {
          err = { ...err, longWorkDesc: true };
          ret = true;
        } else {
          err = { ...err, longWorkDesc: false };
        }
      } else {
        err = {
          ...err,
          longWorkDesc: false,
        };
      }
    } else if (stepState === 2) {
      if (isFormStepActive(4)) {
        if (newWoData.siteExists === "") {
          err = { ...err, siteExists: true };
          ret = true;
        } else if (newWoData.siteExists === "No") {
          err = {
            ...err,
            siteExists: false,
            siteID: false,
            siteAddress: false,
            sitePostalcode: false,
            siteCity: false,
            siteFloor: false,
            siteRow: false,
          };
        } else if (newWoData.siteExists === "Yes") {
          err = { ...err, siteExists: false };

          if (newWoData.siteID === "") {
            err = { ...err, siteID: true };
            ret = true;
          } else {
            err = { ...err, siteID: false };
          }

          if (newWoData.siteAddress === "") {
            err = { ...err, siteAddress: true };
            ret = true;
          } else {
            err = { ...err, siteAddress: false };
          }

          if (!/^[0-9]{3}\s?[0-9]{2}$/.test(newWoData.sitePostalcode)) {
            err = { ...err, sitePostalcode: true };
            ret = true;
          } else {
            err = { ...err, sitePostalcode: false };
          }

          if (newWoData.siteCity === "") {
            err = { ...err, siteCity: true };
            ret = true;
          } else {
            err = { ...err, siteCity: false };
          }

          if (newWoData.siteFloor === "") {
            err = { ...err, siteFloor: true };
            ret = true;
          } else {
            err = { ...err, siteFloor: false };
          }

          if (newWoData.siteRow === "") {
            err = { ...err, siteRow: true };
            ret = true;
          } else {
            err = { ...err, siteRow: false };
          }
        }
      } else {
        err = {
          ...err,
          siteExists: false,
          siteID: false,
          siteAddress: false,
          sitePostalcode: false,
          siteCity: false,
          siteFloor: false,
          siteRow: false,
        };
      }

      if (isFormStepActive(5)) {
        if (newWoData.accessSitePhone === "") {
          err = { ...err, accessSitePhone: false };
        } else {
          if (!/^\+?[0-9]*$/.test(newWoData.accessSitePhone)) {
            err = { ...err, accessSitePhone: true };
            ret = true;
          } else {
            err = { ...err, accessSitePhone: false };
          }
        }

        if (newWoData.accessSitePostalcode === "") {
          err = { ...err, accessSitePostalcode: false };
        } else {
          if (!/^[0-9]{3}\s?[0-9]{2}$/.test(newWoData.accessSitePostalcode)) {
            err = { ...err, accessSitePostalcode: true };
            ret = true;
          } else {
            err = { ...err, accessSitePostalcode: false };
          }
        }
      } else {
        err = {
          ...err,
          accessSitePhone: false,
          accessSitePostalcode: false,
        };
      }

      if (isFormStepActive(6)) {
        if (newWoData.sendMaterial === "") {
          err = { ...err, sendMaterial: true };
          ret = true;
        } else {
          err = { ...err, sendMaterial: false };
        }

        if (newWoData.sendMaterial === "YES") {
          if (
            !newWoData.infoMtrlReturnMtrl ||
            newWoData.infoMtrlReturnMtrl.trim() === ""
          ) {
            err = { ...err, infoMtrlReturnMtrl: true };
            ret = true;
          } else {
            err = { ...err, infoMtrlReturnMtrl: false };
          }
        } else {
          err = { ...err, infoMtrlReturnMtrl: false };
        }
      } else {
        err = {
          ...err,
          sendMaterial: false,
          infoMtrlReturnMtrl: false,
        };
      }
    }

    setValidateIsErr(err);
    return ret;
  }

  function checkNextBtnDisabled_1() {
    return false;
  }

  function checkNextBtnDisabled_2() {
    if (!hasGroup2Steps) {
      return false;
    }

    if (!isFormStepActive(6)) {
      return false;
    }

    if (newWoData.sendMaterial === "") {
      return true;
    }

    if (
      newWoData.sendMaterial === "YES" &&
      (!newWoData.infoMtrlReturnMtrl || !newWoData.infoMtrlReturnMtrl.trim())
    ) {
      return true;
    }

    return false;
  }

  function checkCreateBtnDisabled() {
    return wono.length === 8 || isCreateWoBtnDisabled;
  }

  function checkNextInputFieldsDisabled_2() {
    if (!isFormStepActive(4)) {
      return true;
    }

    if (newWoData.siteExists === "") {
      return true;
    } else if (newWoData.siteExists === "Yes") {
      return false;
    } else if (newWoData.siteExists === "No") {
      return true;
    }

    return true;
  }

  useEffect(() => {
    if (wono.length !== 8) {
      setIsCreateWoBtnDisabled(false);
    }
  }, [wono]);

  if (loading) {
    return (
      <NewWoCreated
        wono={wono}
        setLoading={setLoading}
        updateWoList={updateWoList}
        addingFiles={addingFiles}
        exitWindow={() => {
          setLoading(false);
          setShowCreateWO(false);
        }}
        createWoError={createWoError}
        setCreateWoError={setCreateWoError}
        createWO={createWO}
        nameOfUser={accounts[0].name}
        generatingPDF={generatingPDF}
      />
    );
  }

  switch (stepState) {
    case 1:
      return (
        <Modal
          show={true}
          size="lg"
          fullscreen={"lg-down"}
          scrollable={true}
          className={`modalDialogNewWo ${
            showSavedWorkOrders !== 0 ? " modalDialogNewWoOpenWoOpen" : ""
          }`}
        >
          <Modal.Header className="modal-header divHeader">
            <div className="header_div">
              {hasExtraProducts && (
                <p
                  className="labelStep"
                  style={{
                    float: "left",
                    textAlign: "left",
                    marginLeft: "10px",
                    marginRight: "0",
                  }}
                >
                  Valt avtal: {selectedAgreementId || newWoData.contract_id} -{" "}
                  {selectedAgreementName}
                </p>
              )}

              <p className="labelStep">
                Steg {stepCounter} av {maxStep}
              </p>

              <Progressbar step={stepCounter} maxStep={maxStep} />
            </div>
          </Modal.Header>

          <Modal.Body className="divExtMiddle">
            <GroupedStep1
              setText={setNewWoData}
              text={newWoData}
              ddKommun={kommuner}
              ddProdukt={produkter}
              agreementInfoText={agreementInfoText}
              agreementInfoSeverity={agreementInfoSeverity}
              remValKommun={remValKommun}
              setRemValKommun={setRemValKommun}
              remValLine={remValLine}
              setRemValLine={setRemValLine}
              sla={sla}
              setSla={setSla}
              account={accounts[0]}
              validateIsErr={validateIsErr}
              isBack={isBack}
              setIsBack={setIsBack}
              files={files}
              setFiles={setFiles}
              formToShow={formToShow}
              extraProducts={extraProducts}
              hasExtraProducts={hasExtraProducts}
            />
          </Modal.Body>

          <Modal.Footer>
            <Footer
              nextWindow={nextWindow}
              exitWindow={exitWindow}
              backWindow={backWindow}
              stepState={stepState}
              btnDisabled={checkNextBtnDisabled_1()}
              setChosenWo={setChosenWo}
              showSavedWorkOrders={showSavedWorkOrders}
              setShowSavedWorkOrders={setShowSavedWorkOrders}
              saveWO={saveWO}
            />
          </Modal.Footer>
        </Modal>
      );

    case 2:
      return (
        <Modal
          show={true}
          size="lg"
          fullscreen={"lg-down"}
          className="modalDialog"
        >
          <Modal.Header className="modal-header divHeader">
            <div className="header_div">
              <p className="labelStep">
                Steg {stepCounter} av {maxStep}
              </p>
              <Progressbar step={stepCounter} maxStep={maxStep} />
            </div>
          </Modal.Header>

          <Modal.Body className="divExtMiddle">
            <GroupedStep2
              setText={setNewWoData}
              text={newWoData}
              validateIsErr={validateIsErr}
              disabled={checkNextInputFieldsDisabled_2()}
              deliveryInfo={deliveryAddressInfo}
              deliveryLoading={deliveryAddressLoading}
              deliveryError={deliveryAddressError}
              onRequestDeliveryAddress={requestDeliveryAddress}
              formToShow={formToShow}
            />
          </Modal.Body>

          <Modal.Footer>
            <Footer
              nextWindow={nextWindow}
              exitWindow={exitWindow}
              backWindow={backWindow}
              stepState={stepState}
              btnDisabled={checkNextBtnDisabled_2()}
              saveWO={saveWO}
            />
          </Modal.Footer>
        </Modal>
      );

    case 3:
      return (
        <Modal
          show={true}
          size="lg"
          fullscreen={"lg-down"}
          className="modalDialog"
        >
          <Modal.Header className="modal-header divHeader">
            <div className="header_div">
              <p className="labelStep">
                Steg {stepCounter} av {maxStep}
              </p>
              <Progressbar step={stepCounter} maxStep={maxStep} />
            </div>
          </Modal.Header>

          <Modal.Body className="divExtMiddle">
            <GroupedStep3
              text={newWoData}
              formToShow={formToShow}
              deliveryInfo={deliveryAddressInfo}
            />
          </Modal.Body>

          <Modal.Footer>
            <FooterCreate
              exitWindow={exitWindow}
              backWindow={backWindow}
              stepState={stepState}
              createWO={createWO}
              btnDisabled={checkCreateBtnDisabled()}
              saveWO={saveWO}
            />
          </Modal.Footer>
        </Modal>
      );

    default:
      return (
        <div className="divNewWO">
          <div className="divMiddle">Error</div>
        </div>
      );
  }
};

export default MainWindowGrouped;
